<template lang="html">
  <div id="home-page">

    <section class="banner-section" data-aos="fade">
      <swiper class="swiper desktop" :options="bannersOptions">
        <swiper-slide v-for="(b, bhInx) in banners.desktop" :key="'bhInx-'+bhInx">
          <div class="placed-backg box" v-bind:style="{ backgroundImage: 'url('+b.imageUrl+')' }">
            <img src="public/images/pages/home/banner.png">
          </div>
        </swiper-slide>

        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </swiper>

      <swiper class="swiper mobile" :options="bannersOptions">
        <swiper-slide v-for="(b, bhmInx) in banners.mobile" :key="'bhmInx-'+bhmInx">
          <div class="placed-backg box" v-bind:style="{ backgroundImage: 'url('+b.imageUrl+')' }">
            <img src="public/images/pages/home/banner-m.png">
          </div>
        </swiper-slide>

        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      </swiper>
    </section>

    <section class="container oversized-container events-section">
      <div class="row justify-content-center">
        <div class="col-12 col-top-title">
          <h2>Próximos eventos</h2>
        </div>

        <div class="col-md-6 col-xl-4 col-event-sample-1" v-for="(e, ehInx) in events" :key="'ehInx-'+ehInx">
          <a class="_box_" @click="showEventModal(ehInx)">
            <div class="box-image">
              <img class="placed-backg" src="public/images/pages/home/event.png" v-bind:style="{ backgroundImage: 'url('+e.imageUrl+')' }">
              <div class="bubble available" v-if="e.available == true">Comprar boletos</div>
              <div class="bubble unavailable" v-else>Agotado</div>
            </div>

            <div class="box-descr">
              <div class="col-12 col-place">{{ e.place }}</div>
              <div class="col-12 col-date">
                <span v-if="e.date">{{ e.date }}</span><span v-if="e.hour">, {{ e.hour }}</span>.
              </div>

              <div class="col-12 col-band">{{ e.name }}</div>
              <!-- <div class="col-12 col-price">$820.00 - $1,394.00 MXN</div> -->
            </div>
          </a>
        </div>
      </div>
    </section>

    <section class="sponsors-section">
      <div class="container oversized-container" v-if="false">
        <h5 class="title">Patrocinadores</h5>

        <div class="row">
          <div class="col-lg-9 mx-auto">
            <swiper class="swiper" :options="sponsorsOptions">
              <swiper-slide v-for="(l, lInx) in sponsors" :key="'lInx-'+lInx">
                <div class="box-image">
                  <div class="image">
                    <img :src="l.imageUrl">
                  </div>
                </div>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>

    <section class="note-section">
      <h5>La nueva Sede de los grandes espectáculos.</h5>
    </section>

    <b-modal modal-class="modal-event" ref="modal-event" :size="(modalEvent.size == 'xl') ? 'xl' : '' " title="" hide-footer>
      <div class="row no-gutters">
        <div class="col col-basic-info">
          <div class="box-video" v-if="modalEvent.videoUrl">
            <iframe :src="convertVideoID(modalEvent.videoUrl)" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
          <div class="box-image" v-if="modalEvent.imageUrl && modalEvent.videoUrl == null">
            <img :src="modalEvent.imageUrl">
          </div>

          <div class="box-text">
            <h6 class="title">{{ modalEvent.name }}</h6>
            <h6 class="date">
              <span v-if="modalEvent.date">{{ modalEvent.date }} </span>
              <span v-if="modalEvent.hour">{{ modalEvent.hour }}</span>
            </h6>
            <div class="text-justify" v-html="modalEvent.descr"></div>
            <a class="t-250 btn-s1 bg-green" target="_blank" v-if="modalEvent.url != null" :href="modalEvent.url">Comprar boletos</a>
          </div>
        </div>

        <div class="col col-table">
          <!-- Mariachi Vargas -->
          <div class="table-responsive" v-if="modalEvent.eventNum == 1">
            <table class="table">
              <thead>
                <tr>
                  <th>Zona</th>
                  <th>Mobiliario</th>
                  <th>Opciones de lugares</th>
                  <th>Cada boleto</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>VIP STAGE</td>
                  <td>MESA VIP</td>
                  <td>8</td>
                  <td>$2,599</td>
                </tr>
                <tr>
                  <td>DIAMANTE</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,390</td>
                </tr>
                <tr>
                  <td>VIP BLACK</td>
                  <td>MESA VIP</td>
                  <td>1 a 10</td>
                  <td>$1,950</td>
                </tr>
                <tr>
                  <td>PLATINO IZQ</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,199</td>
                </tr>
                <tr>
                  <td>PLATINO DER</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,199</td>
                </tr>
                <tr>
                  <td>ORO A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$1,950</td>
                </tr>
                <tr>
                  <td>ORO B</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$1,799</td>
                </tr>
                <tr>
                  <td>ORO C</td>
                  <td>MESA VIP</td>
                  <td>1 a 6</td>
                  <td>$1,699</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 2</td>
                  <td>$1,450</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$1,450</td>
                </tr>
                <tr>
                  <td>PLATA IZQ</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$1,450</td>
                </tr>
                <tr>
                  <td>PREMIUM A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$1,750</td>
                </tr>
                <tr>
                  <td>PREMIUM B</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 4</td>
                  <td>$1,650</td>
                </tr>
                <tr>
                  <td>BRONCE A</td>
                  <td>MESA BAJA</td>
                  <td>1 a 5</td>
                  <td>$1,299</td>
                </tr>
                <tr>
                  <td>BRONCE B</td>
                  <td>MESA BAJA</td>
                  <td>1 a 4</td>
                  <td>$1,199</td>
                </tr>
                <tr>
                  <td>ROJA - AZUL</td>
                  <td>SILLA NUMERADA</td>
                  <td>1</td>
                  <td>$599 A $799</td>
                </tr>
                <tr class="website">
                  <td colspan="4">WWW.BOLETOMOVIL.COM</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--  -->

          <!-- Fiesta Sinaloense -->
          <div class="table-responsive" v-if="modalEvent.eventNum == 2">
            <table class="table">
              <thead>
                <tr>
                  <th>Zona</th>
                  <th>Mobiliario</th>
                  <th>Opciones de lugares</th>
                  <th>Cada boleto</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>VIP STAGE</td>
                  <td>MESA VIP</td>
                  <td>8</td>
                  <td>$2,950</td>
                </tr>
                <tr>
                  <td>DIAMANTE</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,890</td>
                </tr>
                <tr>
                  <td>VIP BLACK</td>
                  <td>MESA VIP</td>
                  <td>1 a 10</td>
                  <td>$2,890</td>
                </tr>
                <tr>
                  <td>PLATINO IZQ</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,650</td>
                </tr>
                <tr>
                  <td>PLATINO DER</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,650</td>
                </tr>
                <tr>
                  <td>ORO A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,690</td>
                </tr>
                <tr>
                  <td>ORO B</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,590</td>
                </tr>
                <tr>
                  <td>ORO C</td>
                  <td>MESA VIP</td>
                  <td>1 a 6</td>
                  <td>$2,390</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 2</td>
                  <td>$1,990</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$1,990</td>
                </tr>
                <tr>
                  <td>PLATA IZQ</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$1,990</td>
                </tr>
                <tr>
                  <td>PREMIUM A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,200</td>
                </tr>
                <tr>
                  <td>PREMIUM B</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 4</td>
                  <td>$1,990</td>
                </tr>
                <tr>
                  <td>BRONCE A</td>
                  <td>MESA BAJA</td>
                  <td>1 a 5</td>
                  <td>$1,850</td>
                </tr>
                <tr>
                  <td>BRONCE B</td>
                  <td>MESA BAJA</td>
                  <td>1 a 4</td>
                  <td>$1,650</td>
                </tr>
                <tr>
                  <td>ROJA - AZUL</td>
                  <td>SILLA NUMERADA</td>
                  <td>1</td>
                  <td>$900 A $1,350</td>
                </tr>
                <tr class="website">
                  <td colspan="4">WWW.BOLETOMOVIL.COM</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--  -->

          <!-- Reili Barba -->
          <div class="table-responsive" v-if="modalEvent.eventNum == 3">
            <table class="table">
              <thead>
                <tr>
                  <th>Zona</th>
                  <th>Mobiliario</th>
                  <th>Opciones de lugares</th>
                  <th>Cada boleto</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>VIP STAGE</td>
                  <td>MESA VIP</td>
                  <td>8</td>
                  <td>$2,990</td>
                </tr>
                <tr>
                  <td>DIAMANTE</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,850</td>
                </tr>
                <tr>
                  <td>VIP BLACK</td>
                  <td>MESA VIP</td>
                  <td>1 a 10</td>
                  <td>$2,890</td>
                </tr>
                <tr>
                  <td>PLATINO IZQ</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,750</td>
                </tr>
                <tr>
                  <td>PLATINO DER</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,750</td>
                </tr>
                <tr>
                  <td>ORO A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,590</td>
                </tr>
                <tr>
                  <td>ORO B</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,490</td>
                </tr>
                <tr>
                  <td>ORO C</td>
                  <td>MESA VIP</td>
                  <td>1 a 6</td>
                  <td>$2,290</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 2</td>
                  <td>$1,850</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$1,850</td>
                </tr>
                <tr>
                  <td>PLATA IZQ</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$1,850</td>
                </tr>
                <tr>
                  <td>PREMIUM A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$1,950</td>
                </tr>
                <tr>
                  <td>PREMIUM B</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 4</td>
                  <td>$1,790</td>
                </tr>
                <tr>
                  <td>BRONCE A</td>
                  <td>MESA BAJA</td>
                  <td>1 a 5</td>
                  <td>$1,590</td>
                </tr>
                <tr>
                  <td>BRONCE B</td>
                  <td>MESA BAJA</td>
                  <td>1 a 4</td>
                  <td>$1,490</td>
                </tr>
                <tr>
                  <td>ROJA - AZUL</td>
                  <td>SILLA NUMERADA</td>
                  <td>1</td>
                  <td>$750 A $1,100</td>
                </tr>
                <tr class="website">
                  <td colspan="4">WWW.BOLETOMOVIL.COM</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--  -->

          <!-- Legacy World Tour -->
          <!-- <div class="table-responsive" v-if="modalEvent.eventNum == 4">
            <table class="table">
              <thead>
                <tr>
                  <th>Zona</th>
                  <th>Mobiliario</th>
                  <th>Opciones de lugares</th>
                  <th>Cada boleto</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>VIP STAGE</td>
                  <td>MESA VIP</td>
                  <td>8</td>
                  <td>$2,490</td>
                </tr>
                <tr>
                  <td>DIAMANTE</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,250</td>
                </tr>
                <tr>
                  <td>VIP BLACK</td>
                  <td>MESA VIP</td>
                  <td>1 a 10</td>
                  <td>$1,950</td>
                </tr>
                <tr>
                  <td>PLATINO IZQ</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,150</td>
                </tr>
                <tr>
                  <td>PLATINO DER</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,150</td>
                </tr>
                <tr>
                  <td>ORO A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$1,900</td>
                </tr>
                <tr>
                  <td>ORO B</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$1,800</td>
                </tr>
                <tr>
                  <td>ORO C</td>
                  <td>MESA VIP</td>
                  <td>1 a 6</td>
                  <td>$1,790</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 2</td>
                  <td>$1,450</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$1,450</td>
                </tr>
                <tr>
                  <td>PLATA IZQ</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$1,450</td>
                </tr>
                <tr>
                  <td>PREMIUM A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$1,500</td>
                </tr>
                <tr>
                  <td>PREMIUM B</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 4</td>
                  <td>$1,350</td>
                </tr>
                <tr>
                  <td>BRONCE A</td>
                  <td>MESA BAJA</td>
                  <td>1 a 5</td>
                  <td>$1,100</td>
                </tr>
                <tr>
                  <td>BRONCE B</td>
                  <td>MESA BAJA</td>
                  <td>1 a 4</td>
                  <td>$990</td>
                </tr>
                <tr>
                  <td>ROJA - AZUL</td>
                  <td>SILLA NUMERADA</td>
                  <td>1</td>
                  <td>$499 A $799</td>
                </tr>
                <tr class="website">
                  <td colspan="4">WWW.BOLETOMOVIL.COM</td>
                </tr>
              </tbody>
            </table>
          </div> -->
          <!--  -->

          <!-- Ricardo Montaner -->
          <div class="table-responsive" v-if="modalEvent.eventNum == 5">
            <table class="table">
              <thead>
                <tr>
                  <th>Zona</th>
                  <th>Mobiliario</th>
                  <th>Opciones de lugares</th>
                  <th>Cada boleto</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>VIP STAGE</td>
                  <td>MESA VIP</td>
                  <td>8</td>
                  <td>$3,950</td>
                </tr>
                <tr>
                  <td>DIAMANTE</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$3,450</td>
                </tr>
                <tr>
                  <td>VIP BLACK</td>
                  <td>MESA VIP</td>
                  <td>1 a 10</td>
                  <td>$3,350</td>
                </tr>
                <tr>
                  <td>PLATINO IZQ</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$3,350</td>
                </tr>
                <tr>
                  <td>PLATINO DER</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$3,350</td>
                </tr>
                <tr>
                  <td>ORO A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$3,150</td>
                </tr>
                <tr>
                  <td>ORO B</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,850</td>
                </tr>
                <tr>
                  <td>ORO C</td>
                  <td>MESA VIP</td>
                  <td>1 a 6</td>
                  <td>$2,750</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 2</td>
                  <td>$2,350</td>
                </tr>
                <tr>
                  <td>PLATA DER</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$2,350</td>
                </tr>
                <tr>
                  <td>PLATA IZQ</td>
                  <td>MESA ALTA</td>
                  <td>1 a 4</td>
                  <td>$2,350</td>
                </tr>
                <tr>
                  <td>PREMIUM A</td>
                  <td>MESA VIP</td>
                  <td>1 a 8</td>
                  <td>$2,550</td>
                </tr>
                <tr>
                  <td>PREMIUM B</td>
                  <td>MESA ELEGANCE</td>
                  <td>1 a 4</td>
                  <td>$2,350</td>
                </tr>
                <tr>
                  <td>BRONCE A</td>
                  <td>MESA BAJA</td>
                  <td>1 a 5</td>
                  <td>$1,950</td>
                </tr>
                <tr>
                  <td>BRONCE B</td>
                  <td>MESA BAJA</td>
                  <td>1 a 4</td>
                  <td>$1,800</td>
                </tr>
                <tr>
                  <td>ROJA - AZUL</td>
                  <td>SILLA NUMERADA</td>
                  <td>1</td>
                  <td>$650 A $950</td>
                </tr>
                <tr class="website">
                  <td colspan="4">WWW.BOLETOMOVIL.COM</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--  -->
        </div>
      </div>
    </b-modal>

    <b-modal modal-class="modal-event" ref="modal-cancel" size="xl" title="" hide-footer>
      <img class="w-100" src="public/images/pages/home/cancel.jpg" />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: {
        desktop: [
          { imageUrl: 'public/images/pages/home/banner-1.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-34.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-31.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-36.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-37.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-35.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-32.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-38.jpg' },
          { imageUrl: 'public/images/pages/home/banner-39.jpg' },
          { imageUrl: 'public/images/pages/home/banner-40.jpg' },
        ],

        mobile: [
          { imageUrl: 'public/images/pages/home/banner-1-m.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-34-m.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-31-m.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-36-m.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-37-m.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-35-m.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-32-m.jpg' },
          // { imageUrl: 'public/images/pages/home/banner-38-m.jpg' },
          { imageUrl: 'public/images/pages/home/banner-39-m.jpg' },
          { imageUrl: 'public/images/pages/home/banner-40-m.jpg' },
        ]
      },

      modalEvent: {
        eventNum: null,
        imageUrl: null,
        videoUrl: null,
        name: null,
        url: null,
        date: null,
        hour: null,
        size: null,
      },

      events: [
        // {
        //   eventNum: 5,
        //   imageUrl: 'public/images/pages/home/event-5.jpg',
        //   videoUrl: 'https://www.youtube.com/watch?v=C3Ljphz7-H8',
        //   available: true,
        //   place: 'SEDE STAGE SHOW CENTER',
        //   date: '14/Oct/2023',
        //   hour: '9:45 PM',
        //   name: 'Ricardo Montaner',
        //   url: 'https://boletomovil.com/evento/ricardo-montaner-2023-10-14?utm_source=web_sedestage&utm_medium=sitio_sedestage&utm_campaign=sitioweb_ricardomoontaner_sedestage',
        //   descr: '<p>El cantautor venezolano Ricardo Montaner, regresa a Guadalajara con su nueva gira internacional "Te Echo De Menos". Con "Tango", su última producción bajo el brazo y sus clásicos de siempre como "Tan Enamorados", "Bésame", "Me Va A Extrañar" y "El Poder De Tu Amor", Montaner promete una noche llena de nostalgia y romanticismo para el público mexicano.</p>',
        //   size: 'xl',
        // },
        // {
        //   eventNum: 25,
        //   imageUrl: 'public/images/pages/home/event-25.jpg',
        //   videoUrl: null,
        //   available: true,
        //   place: 'SEDE STAGE SHOW CENTER',
        //   date: '20/Julio/2025',
        //   hour: '5:00 PM | 8:00 PM',
        //   name: 'Ahí viene... El Briago de Ozzz',
        //   url: 'https://www.ticketmaster.com.mx/search?q=briago',
        //   descr: null,
        //   size: 'sm',
        // },
        // {
        //   eventNum: 38,
        //   imageUrl: 'public/images/pages/home/event-38.jpg',
        //   videoUrl: null,
        //   available: true,
        //   place: 'SEDE STAGE SHOW CENTER',
        //   date: '26/Abril/2026',
        //   hour: '5:00 PM',
        //   name: 'Las Guerreras K-Pop',
        //   url: 'https://boletopolis.com/es/evento/39248',
        //   descr: 'Prepárate para vivir una tarde llena de ritmo, energía y emoción en un espectáculo que combina lo mejor del teatro musical, la danza urbana y la fantasía pop coreana.',
        //   size: 'sm',
        // },
        {
          eventNum: 39,
          imageUrl: 'public/images/pages/home/event-39.jpg',
          videoUrl: null,
          available: true,
          place: 'SEDE STAGE SHOW CENTER',
          date: '5/Julio/2026',
          hour: '5:00 PM',
          name: 'La Sirenita',
          url: 'https://boletopolis.com/es/evento/39943',
          descr: null,
          size: 'sm',
        },
        {
          eventNum: 40,
          imageUrl: 'public/images/pages/home/event-40.jpg',
          videoUrl: null,
          available: true,
          place: 'SEDE STAGE SHOW CENTER',
          date: '9/Agosto/2026',
          hour: '5:00 PM',
          name: 'MOANA',
          url: 'https://boletopolis.com/es/evento/40318',
          descr: null,
          size: 'sm',
        },
      ],

      sponsors: [
        { imageUrl: 'public/images/pages/home/logo-1.png' },
        // { imageUrl: 'public/images/pages/home/logo-2.png' },
        { imageUrl: 'public/images/pages/home/logo-3.png' },
        //{ imageUrl: 'public/images/pages/home/logo-2.png' },
        //{ imageUrl: 'public/images/pages/home/logo-3.png' },
        // { imageUrl: 'public/images/pages/home/logo-4.png' },
      ],

      // == Carousel options ==
      bannersOptions: {
        effect: 'fade',
        loop: true,
        speed: 700,

        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },

      sponsorsOptions: {
        slidesPerView: 2,
        spaceBetween: 10,

        autoplay: {
          delay: 200000,
          disableOnInteraction: false
        },

        breakpoints: {
          1200: {
            slidesPerView: 2,
            spaceBetween: 10,

            autoplay: {
              delay: 200000,
              disableOnInteraction: false
            },
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,

            autoplay: {
              delay: 200000,
              disableOnInteraction: false
            },
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 30,

            autoplay: {
              delay: 4000,
              disableOnInteraction: false
            },
          },
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      }
      // == ==
    }
  },

  methods: {
    convertVideoID (url) {
      if(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(shorts\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        var ytBaselink = 'https://www.youtube.com/embed/';
        var ytID = (match&&match[8].length==11)? match[8] : false;
        return ytBaselink + ytID + '?rel=0';
      }
    },

    showEventModal(idx) {
      this.modalEvent = this.events[idx];
      this.$refs['modal-event'].show();
    },
  },

  mounted() {
    // this.$refs['modal-cancel'].show();
  }
}
</script>
